import { AllAliasTypeValues } from '@cbinsights/cbientityservice/cbientityservice';
import { request } from 'client/modules/common/utils/request';

export const getAllAliasTypeValues = (): Promise<AllAliasTypeValues> => {
  return request({
    url: '/service/cbientityservice/GetAllAliasTypeValues',
  }).then((r): AllAliasTypeValues => r.body);
};
